import React, { useState, useEffect, useCallback, useRef } from "react";
import _ from "lodash";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import "../../pages/_Components/ReactBeautifulDnd.css";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import { useForm, Controller } from "react-hook-form";
import { Button, Modal, Col, Row, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import { NumericFormat, PatternFormat } from "react-number-format";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Swal from "sweetalert2";
import { numberRegex } from "../../../core/utils/tools";
import HTMLInput from "../_Components/HTMLInput";
import SelectComponent from "../_Components/ReactSelectComponent";
import { isMobile } from "react-device-detect";



const supplierSettlementTypeEnum = [
  { value: 1, label: "تسویه در وضعیت بلیط رزرو" },
  { value: 2, label: "تسویه در وضعیت بلیط استفاده شده" },
];
const issueTicketTypeEnum = [
  { value: 1, label: "صدور بلیط خارج از سامانه" },
  { value: 2, label: "صدور بلیط توسط سامانه" },
];



const ReserveItemPricingAndCommissionModal = ({ showModalReserveItemPricingAndCommission, setShowModalReserveItemPricingAndCommission,
  suppliers, selectedReserveItem }) => {
  const [amusementServiceReserveItem, setAmusementServiceReserveItem] = useState();
  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };
  const scrollableBox = useRef()
  const {
    handleSubmit,
    register,
    control,
    formState: { errors, isSubmitting },
    reset,
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      id: 0,
      amusementServiceId: 0,
      defaultReserveCountPerDay: 10,
      reservationExpirationTime: "23:59",
      isDisplay: true,
      isActive: true,
      supplierSettlementType: { value: 2, label: "تسویه در وضعیت بلیط استفاده شده" },
      issueTicketType: { value: 1, label: "صدور بلیط خارج از سامانه " },
      amusementServiceId: null,
      supplierId: null,
    },
  });
  const [maxTakhfif, setMaxTakhfif] = useState()
  const percentOnInput = useCallback((e, inputName) => {
    if (e.target.value > 100) e.target.value = 100;
    if (!numberRegex.test(e.target.value) && e.target.value) {
      e.target.value = getValues(inputName)
      return
    }
  }, [])

  const issueTicketTypeSelect = watch("issueTicketType");
  const supplierSettlementTypeSelect = watch("supplierSettlementType");
  const supplierAutoSettlementCheckBox = watch("supplierAutoSettlement");

  const supplierIdText = watch("supplierId");
  const supplierSettlementPriceText = watch("supplierSettlementPrice");
  const cleanAmount =
    typeof supplierSettlementPriceText === "string"
      ? supplierSettlementPriceText.replace(/,/g, "")
      : supplierSettlementPriceText;
  const supplierSettlementPriceformattedAmount = cleanAmount ? Number(cleanAmount).toLocaleString("en-US") : "—";

  const showMsg =
    (issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1) ||
    (issueTicketTypeSelect?.value === 1 && supplierAutoSettlementCheckBox === true);
  const formatNumber = (value) => {
    const stringValue = String(value);
    return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  useEffect(() => {
    const fetchReserveItem = async () => {
      if (selectedReserveItem.id !== 0) {
        try {
          const response = await ApiAmusementServiceReserveItem.getAmusementServiceReserveItemAndCommissions(selectedReserveItem.id);
          setAmusementServiceReserveItem(response);
          setValue("id", response.id);
          setValue("amusementServiceId", response.amusementServiceId);
          setValue("price", response.price);
          setValue("originalPrice", response.originalPrice);
          setValue("supplierAutoSettlement", response.supplierAutoSettlement);
          setValue("defaultReserveCountPerDay", response.defaultReserveCountPerDay);
          setValue("minimumReserveCountPerDay", response.minimumReserveCountPerDay);
          setValue("reservationExpirationTime", response.reservationExpirationTime);
          setValue("executionTime", response.executionTime);
          setValue("supplierSettlementPrice", response.supplierSettlementPrice);
          setValue(
            "supplierSettlementType",
            supplierSettlementTypeEnum.find((item) => item.value === response.supplierSettlementType),
          );
          setValue(
            "issueTicketType",
            issueTicketTypeEnum.find((item) => item.value === response.issueTicketType),
          );
          setValue("reservationByPhone", response.reservationByPhone);
          setMaxTakhfif(response.price - (response.supplierSettlementPrice ?? 0))
          if (response.supplierId) {
            const initialSupplier = suppliers.find((supplier) => supplier.id === response.supplierId);
            if (initialSupplier) {
              const selectedOption = {
                value: initialSupplier.id,
                label: initialSupplier.companyName,
              };
              setValue("supplierId", selectedOption);
            }
          }
          //مقادیر کمیسیون و گروه تخفیف
          response.promoCategories?.forEach((category) => {
            const commissionObjs = category.promoCategoryCommissions.length ? category.promoCategoryCommissions : [1];
            commissionObjs.forEach((commissionObj) => {
              const discountFields = JSON.parse(category.amusementServiceFormFieldIds || "[]");
              const discountField = discountFields.find(f => f.id == selectedReserveItem.id);

              const promoCategoryDiscountPriceRaw = discountField ? discountField.discountprice : 0;

              const promoCategoryDiscountPriceNum = Number(String(promoCategoryDiscountPriceRaw).replaceAll(',', '')) || 0;

              const profit = response.price - response.supplierSettlementPrice;
              const discountPercentage = (profit !== 0) ? +((promoCategoryDiscountPriceNum * 100) / profit).toFixed(2) : 0;
              const discountPercentageStr = Number.isInteger(discountPercentage) ? discountPercentage.toString() : discountPercentage.toFixed(2);

              setValue(
                `discountAmount_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`,
                formatNumber(promoCategoryDiscountPriceNum)
              );
              setValue(
                `discountPercent_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`,
                discountPercentageStr
              );
              const commissionFields = JSON.parse(commissionObj.amusementServiceFormFieldIds || "[]");
              const commissionField = commissionFields.find(f => f.id == selectedReserveItem.id);
              const commissionDiscountPriceRaw = commissionField ? commissionField.discountpriceCommision ?? 0 : 0;

              const commissionDiscountPriceNum = Number(String(commissionDiscountPriceRaw).replaceAll(',', '')) || 0;

              const commissionPercentage = (profit !== 0) ? +((commissionDiscountPriceNum * 100) / profit).toFixed(2) : 0;
              const commissionPercentageStr = Number.isInteger(commissionPercentage) ? commissionPercentage.toString() : commissionPercentage.toFixed(2);

              setValue(`commissionPercent_${commissionObj.promoCategoryCommisionId}`, commissionPercentageStr);
              setValue(`commissionAmount_${commissionObj.promoCategoryCommisionId}`, formatNumber(commissionDiscountPriceNum));

              const finalProfit = profit - promoCategoryDiscountPriceNum - commissionDiscountPriceNum;
              setValue(`profit_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`, formatNumber(finalProfit));
            });
          });
        } catch (error) {
        }
      } else {
        reset({
          id: 0,
          defaultReserveCountPerDay: 10,
          reservationExpirationTime: "23:59",
          supplierSettlementType: { value: 2, label: "تسویه در وضعیت بلیط استفاده شده" },
          issueTicketType: { value: 1, label: "صدور بلیط خارج از سامانه " },
          amusementServiceId: 0,
          supplierId: null,
        });
      }
    };

    fetchReserveItem();
  }, [selectedReserveItem.id, setValue]);
  const handleClose = () => {
    setShowModalReserveItemPricingAndCommission(false);
  };
  const handleChangeIsNumber = (event, onChange) => {
    const value = event.target.value;
    const label = event.target.closest(".MuiTextField-root")?.querySelector("label")?.innerHTML
    // فقط مقادیر عددی بزرگتر از 0 مجاز باشند
    if (/^[0-9]\d*$|^$/.test(value)) {
      // فیلد تماس تلفنی باید 11 رقم باشد
      if (label == "تماس تلفنی" && (value.length > 11 || value.length < 0)) return
      onChange(value); // مقدار ورودی را به‌روزرسانی می‌کنیم
    }
  };

  // تغییرات نرخ فروش و مبلغ پرداختی به تامین کننده => آپدیت گروه های تخفیف و کمیسیون
  const updateCommissionFields = (newValue, fieldName) => {
    // بروزرسانی فرم
    setValue(fieldName, newValue);

    // profit بر اساس قیمت فروش و قیمت تسویه با تامین کننده
    const price = getValues("price") || 0;
    const supplierSettlementPrice = getValues("supplierSettlementPrice") || 0;
    const profit = price - supplierSettlementPrice;
    setMaxTakhfif(profit)
    amusementServiceReserveItem.promoCategories.forEach((category) => {
      const commissionObjs = category.promoCategoryCommissions.length ? category.promoCategoryCommissions : [1];
      commissionObjs.forEach((commissionObj) => {
        // بروزرسانی مبلغ تخفیف
        const discountPercent = getValues(`discountPercent_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`) || 0;
        let discountAmount = (profit * discountPercent) / 100;
        discountAmount = discountAmount < 0 ? 0 : discountAmount; // مبلغ تخفیف منفی نشود
        setValue(`discountAmount_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`, formatNumber(discountAmount.toFixed()));

        // بروزرسانی کمیسیون
        const commissionPercent = getValues(`commissionPercent_${commissionObj.promoCategoryCommisionId}`) || 0;
        let commissionAmount = (profit * commissionPercent) / 100;
        commissionAmount = commissionAmount < 0 ? 0 : commissionAmount;// مبلغ کمیسیون منفی نشود
        setValue(`commissionAmount_${commissionObj.promoCategoryCommisionId}`, formatNumber(commissionAmount.toFixed()));

        // بروزرسانی سود نهایی
        const finalProfit = profit - discountAmount - commissionAmount;
        setValue(`profit_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`, formatNumber(finalProfit.toFixed()));
      });
    });
  };

  // محاسبه سود با تغییر تخفیف و کمیسیون
  const updateProfit = (newValue, fieldName, promoCategoryId, commissionId) => {
    if (!numberRegex.test(newValue.replaceAll(",", "")) && newValue) {
      return
    }

    //  فقط عدد
    const numberValue = String(newValue).replace(/[^0-9.]/g, "");
    const price = +getValues("price") || 0;
    const supplierSettlementPrice = +getValues("supplierSettlementPrice") || 0;
    const baseProfit = price - supplierSettlementPrice;

    let discountAmount = 0;
    let commissionAmount = 0;

    // --- درصد یا مبلغ تخفیف ---
    if (fieldName.includes("discountAmount_")) {
      discountAmount = newValue.replaceAll(",", "");
      const discountPercent = baseProfit !== 0 ? ((discountAmount.replaceAll(",", "") / baseProfit) * 100) : 0;
      const discountPercentageStr = Number.isInteger(+discountPercent) ? discountPercent : (+discountPercent).toFixed(2);

      setValue(fieldName, formatNumber(numberValue));
      setValue(`discountPercent_${promoCategoryId}_${commissionId}`, discountPercentageStr);

    } else if (fieldName.includes("discountPercent_")) {
      const percent = newValue;
      discountAmount = (baseProfit * percent) / 100;
      discountAmount = discountAmount < 0 ? 0 : discountAmount; // مبلغ تخفیف منفی نشود
      setValue(fieldName, numberValue); // درصد را بدون کاما نگه دار
      setValue(
        `discountAmount_${promoCategoryId}_${commissionId}`,
        formatNumber(discountAmount.toFixed())
      );
    }

    // --- درصد یا مبلغ کمیسیون ---
    else if (fieldName.includes("commissionAmount_")) {
      commissionAmount = newValue.replaceAll(",", "");
      const commissionPercent = baseProfit !== 0 ? (commissionAmount.replaceAll(",", "") / baseProfit) * 100 : 0;
      const commissionPercentageStr = Number.isInteger(commissionPercent) ? commissionPercent : (+commissionPercent).toFixed(2);

      setValue(fieldName, formatNumber(numberValue));
      setValue(`commissionPercent_${commissionId}`, commissionPercentageStr);

    } else if (fieldName.includes("commissionPercent_")) {
      const percent = newValue;
      commissionAmount = (baseProfit * percent) / 100;
      commissionAmount = commissionAmount < 0 ? 0 : commissionAmount; // مبلغ کمیسیون منفی نشود
      setValue(fieldName, numberValue);
      setValue(`commissionAmount_${commissionId}`, formatNumber(commissionAmount.toFixed()));
    }

    // --- سود نهایی ---
    const finalDiscountAmount =
      discountAmount ||
      +getValues(`discountAmount_${promoCategoryId}_${commissionId}`)?.replaceAll(",", "") ||
      0;

    const finalCommissionAmount =
      commissionAmount ||
      +getValues(`commissionAmount_${commissionId}`)?.replaceAll(",", "") ||
      0;
    const finalProfit = baseProfit - finalDiscountAmount - finalCommissionAmount;
    setValue(`profit_${promoCategoryId}_${commissionId}`, formatNumber(finalProfit.toFixed()));
  };

  const onSubmit = async (data) => {
    if (data.supplierId !== null && Number(data.supplierSettlementPrice) === 0) {
      const resultSweetAlert = await Swal.fire({
        // title: "تایید عملیات درج",
        text: "تامین کننده تفریح انتخاب شده و مبلغ پرداختی به تامین کننده صفر می باشد. در صورت مغایرت مبلغ پرداخت به تامین کننده جهت جلوگیری از بروز مشکل آن را تغییر دهید در غیراین صورت روی دکمه تایید کلیک نمایید",
        showDenyButton: true,
        showCancelButton: false,
        icon: "question",
        confirmButtonText: "تایید",
        denyButtonText: "انصراف",
        // cancelButtonText: "انصراف",
        customClass: {
          actions: "my-actions",
          //cancelButton: "order-1 right-gap btn btn-secondary px-3",
          confirmButton: "order-2 btn btn-success px-5",
          denyButton: "order-3 btn btn-danger px-5",
        },
        focusCancel: true
      });

      if (!resultSweetAlert.isConfirmed) {
        return;
      }
    }
    data.originalPrice =
      data.originalPrice && data.originalPrice.length > 0
        ? data.originalPrice?.replaceAll(" ", "")?.replaceAll(",", "")
        : data.originalPrice;
    data.price = data.price && data.price.length > 0 ? data.price?.replaceAll(" ", "")?.replaceAll(",", "") : data.price;
    data.supplierSettlementPrice =
      data.supplierSettlementPrice && data.supplierSettlementPrice.length > 0
        ? data.supplierSettlementPrice?.replaceAll(" ", "")?.replaceAll(",", "")
        : data.supplierSettlementPrice;
    data.supplierSettlementType = data?.supplierSettlementType?.value;
    data.issueTicketType = data?.issueTicketType?.value;
    data.supplierId = data.supplierId?.value;
    data.minimumReserveCountPerDay = +data.minimumReserveCountPerDay;

    if (Number(data.originalPrice) < Number(data.price)) {
      SwalMessage({ title: "قیمت نمی تواند بیشتر از قیمت اصلی آیتم باشد.", iSsuccess: false, timer: 5000 });
      return;
    }
    //************* چک کردن سود نهایی در صورت منفی شدن آلرت نشون میده
    const profitsElements = document.querySelectorAll("input[title='سود نهایی']")
    const profits = []
    for (const el of profitsElements) {
      profits.push(+el.value?.replaceAll(",", ""))
    }
    if (profits.some(profit => profit < 0)) {
      const resultSweetAlert = await Swal.fire({
        title: "سود منفی",
        html: `مبلغ سود نهایی سیستم ${amusementServiceReserveItem?.promoCategories.length > 0 ? "در یک یا چند گروه تخفیف" : ""} منفی شده است در نتیجه پس از رزرو این آیتم به جای سود ضرر میکنیم. <br/> آیا ثبت نهایی انجام شود؟`,
        showDenyButton: true,
        showCancelButton: false,
        icon: "error",
        confirmButtonText: "تایید",
        denyButtonText: "انصراف",
        // cancelButtonText: "انصراف",
        customClass: {
          actions: "my-actions",
          //cancelButton: "order-1 right-gap btn btn-secondary px-3",
          confirmButton: "order-2 btn btn-success px-5",
          denyButton: "order-3 btn btn-danger px-5",
        },
        focusConfirm: true,
      });

      if (!resultSweetAlert.isConfirmed) {
        return;
      }
    }
    const structuredData = {
      id: data.id,
      amusementServiceId: data.amusementServiceId,
      price: data.price,
      originalPrice: data.originalPrice,
      supplierId: data.supplierId,
      issueTicketType: data.issueTicketType,
      amusementServiceId: data.amusementServiceId,
      supplierSettlementType: data.supplierSettlementType,
      supplierSettlementPrice: data.supplierSettlementPrice,
      minimumReserveCountPerDay: data.minimumReserveCountPerDay,
      reservationByPhone: data.reservationByPhone,
      supplierAutoSettlement: data.supplierAutoSettlement,
      executionTime: data.executionTime,
      reservationExpirationTime: data.reservationExpirationTime,
      defaultReserveCountPerDay: data.defaultReserveCountPerDay,
      promoCategories: [],
      promoCategoryCommissions: []
    };
    //******************** گروه های تخفیف و کمیسیون ها*/
    amusementServiceReserveItem.promoCategories.forEach((category) => {
      const commissionObjs = category.promoCategoryCommissions.length ? category.promoCategoryCommissions : [1];
      commissionObjs.forEach((commissionObj) => {
        // گروه تخفیف
        var existingCategory = structuredData.promoCategories.find(a => a.promoCategoryId == category.promoCategoryId);
        if (!existingCategory) {
          let discountAmount = +getValues(`discountAmount_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`)?.replaceAll(",", "") || 0;
          structuredData.promoCategories.push({
            promoCategoryId: category.promoCategoryId,
            discountPrice: discountAmount,
            discountPricePercent: 0,
          });
        }
        // کمیسیون
        var existingCommission = structuredData.promoCategoryCommissions.find(a => a.promoCategoryCommisionId == commissionObj.promoCategoryCommisionId);
        if (!existingCommission) {
          let commissionAmount = +getValues(`commissionAmount_${commissionObj.promoCategoryCommisionId}`)?.replaceAll(",", "") || 0;
          structuredData.promoCategoryCommissions.push({
            promoCategoryCommissionId: commissionObj.promoCategoryCommisionId,
            discountPriceCommission: commissionAmount,
          });
        }
      });
    });
    try {
      let response = await ApiAmusementServiceReserveItem.updateReserveItemPricingAndCommission(structuredData);
      if (response.succeeded == true) document.getElementById("submitButton").click();
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      setShowModalReserveItemPricingAndCommission(false);
    } catch (error) {
    }
  };


  return (
    <div>
      <div className="card-body pt-3 pb-0">
        <Modal centered show={showModalReserveItemPricingAndCommission} size="xl" onHide={handleClose}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {"قیمت‌گذاری و کمیسیون تخفیف"} {amusementServiceReserveItem?.title}{selectedReserveItem && " - " + selectedReserveItem.amusementServiceName}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="d-flex align-items-stretch">
                {/* قیمت‌گذاری */}
                <Col xl="6" className="d-flex mt-5">
                  <div
                    className="rounded-2 px-3 py-1 pb-5 mt-5 w-100 h-100 d-flex flex-column"
                    style={{ border: "3px solid #81aced" }}
                  >
                    <div
                      className="bg-white px-3 position-absolute d-inline-block text-primary"
                      style={{ marginTop: "-14px", width: "auto" }}
                    >
                      قیمت گذاری
                    </div>
                    <Row className="mt-3">
                      <Col xs="12" xl="6">
                        <Controller
                          name="originalPrice"
                          control={control}
                          rules={{ required: true }}
                          render={({ field: { onChange, value } }) => (
                            <NumericFormat
                              customInput={TextField}
                              label="قیمت مصوب"
                              margin="normal"
                              variant="outlined"
                              type="search"
                              size="small"
                              value={value || ""}
                              onChange={onChange}
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                              thousandSeparator=","
                            />
                          )}
                        />
                        {errors.originalPrice && <div className="mt-2 pl-4 text-danger">**لطفا قیمت را وارد نمایید</div>}
                      </Col>
                      <Col xs="12" xl="6">
                        <Controller
                          name="price"
                          control={control}
                          rules={{ required: true }}
                          render={({ field: { onChange, value } }) => (
                            <NumericFormat
                              customInput={TextField}
                              label="قیمت فروش"
                              margin="normal"
                              variant="outlined"
                              type="search"
                              size="small"
                              value={value || ""}
                              thousandSeparator=","
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                              // onValueChange={(values) => updateCommissionFields(values.floatValue || 0, "price")}
                              onValueChange={(values) => {
                                if (getValues("price") !== values.floatValue) {
                                  updateCommissionFields(values.floatValue || 0, "price");
                                }
                              }}
                            />
                          )}
                        />

                        {errors.price && <div className="mt-2 pl-4 text-danger">**لطفا قیمت را وارد نمایید</div>}
                      </Col>
                      <Col xs="12" xl="3">
                        <Controller
                          name="minimumReserveCountPerDay"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              label="حداقل تعداد"
                              type="text"
                              margin="normal"
                              variant="outlined"
                              size="small"
                              value={field.value || ""}
                              onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                            />
                          )}
                        />
                      </Col>
                      <Col xs="12" xl="3">
                        <Controller
                          name="defaultReserveCountPerDay"
                          control={control}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <TextField
                              label="ظرفیت روزانه"
                              type="text"
                              margin="normal"
                              variant="outlined"
                              size="small"
                              value={field.value || ""}
                              onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                            />
                          )}
                        />
                        {errors.defaultReserveCountPerDay && (
                          <div className="mt-2 pl-4 text-danger">**لطفاظرفیت روزانه را وارد نمایید</div>
                        )}
                      </Col>
                      <Col xs="12" xl="6">
                        <Controller
                          name="reservationExpirationTime"
                          control={control}
                          rules={{ required: false }}
                          render={({ field: { onChange, value } }) => (
                            <PatternFormat
                              customInput={TextField}
                              label="ساعت اتمام فروش"
                              size="small"
                              margin="normal"
                              type="search"
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                              value={value || ""}
                              variant="outlined"
                              onChange={onChange}
                              placeholder="00:00"
                              format="##:##"
                              allowEmptyFormatting={false}
                              defaultValue="23:59"
                            />
                          )}
                        />
                        {errors.reservationExpirationTime && (
                          <div className="mt-2 pl-4 text-danger">**لطفا ساعت اتمام فروش را وارد نمایید</div>
                        )}
                      </Col>
                      <Col xs="12" xl="6">
                        <Controller
                          name="executionTime"
                          control={control}
                          rules={{ required: false }}
                          render={({ field: { onChange, value } }) => (
                            <PatternFormat
                              customInput={TextField}
                              label="زمان انجام برنامه"
                              size="small"
                              margin="normal"
                              type="search"
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                              value={value || ""}
                              variant="outlined"
                              onChange={onChange}
                              placeholder="00:00"
                              format="##:##"
                              allowEmptyFormatting={false}
                              defaultValue="23:59"
                            />
                          )}
                        />
                      </Col>
                      <Col xs="12" xl="6" className="d-flex align-items-center">
                        <Controller
                          name="reservationByPhone"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <TextField
                              label="تماس تلفنی"
                              margin="normal"
                              variant="outlined"
                              size="small"
                              value={value || ""}
                              onInput={(e) => handleChangeIsNumber(e, onChange)}
                            />
                          )}
                        />
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-top">
                              در صورتی که این فیلد پر شود، آیتم موردنظر در سایت تفریحان قابل رزرو به صورت آنلاین نیست و
                              عنوان نمایشی « رزرو تلفنی » نمایش داده می شود.
                            </Tooltip>
                          }
                        >
                          <i className="fa fa-info-circle ml-1 mt-1"></i>
                        </OverlayTrigger>
                      </Col>

                    </Row>
                  </div>
                </Col>

                <Col xl="6" className="d-flex mt-5">
                  <div
                    className="rounded-2 px-3 pb-5 mt-5 py-1 w-100 h-100 d-flex flex-column"
                    style={{ border: "3px solid #81aced" }}
                  >
                    <div
                      className="bg-white px-3 position-absolute d-inline-block text-primary"
                      style={{ marginTop: "-14px", width: "auto" }}
                    >
                      تسویه و صدور بلیط
                    </div>
                    <Row className="mt-3">
                      <Col xs="12" xl="6" style={{ zIndex: "3" }}>
                        <Controller
                          name="supplierId"
                          control={control}
                          render={({ field: { onChange } }) => (
                            <SelectComponent
                              name="supplierId"
                              style={selectStyles}
                              inputId="react-select-with-search"
                              className="w-100 mt-5"
                              variant="outlined"
                              size="small"
                              placeholder="تامین کننده"
                              TextFieldProps={{
                                label: "Supplier",
                                InputLabelProps: {
                                  htmlFor: "react-select-multiple",
                                  shrink: true,
                                },
                              }}
                              options={suppliers?.map((item) => ({
                                value: item.id,
                                label: item.companyName,
                              }))}
                              value={getValues("supplierId") || ""}
                              onChange={onChange}
                            />
                          )}
                        />
                      </Col>
                      <Col xs="12" xl="6">
                        <Controller
                          name="supplierSettlementPrice"
                          control={control}
                          rules={{ required: supplierIdText ? true : false }}
                          render={({ field: { onChange, value } }) => (
                            <NumericFormat
                              customInput={TextField}
                              label="قیمت تسویه با تامین کننده"
                              margin="normal"
                              type="search"
                              variant="outlined"
                              size="small"
                              value={value || ""}
                              thousandSeparator=","
                              //onValueChange={(values) => updateCommissionFields(values.floatValue || 0, "supplierSettlementPrice")}
                              onValueChange={(values) => {
                                if (getValues("supplierSettlementPrice") !== values.floatValue) {
                                  updateCommissionFields(values.floatValue || 0, "supplierSettlementPrice");
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                            />
                          )}
                        />

                        {errors.supplierSettlementPrice && (
                          <div className="mt-2 pl-4 text-danger">**قیمت تسویه با تامین کننده را وارد کنید</div>
                        )}

                      </Col>
                      <Col xs="12" xl="6">
                        <Controller
                          name="supplierSettlementType"
                          control={control}
                          // rules={{ required: true, }}
                          render={({ field: { onChange } }) => (
                            <SelectComponent
                              name="supplierSettlementType"
                              className="w-100 mt-2"
                              variant="outlined"
                              size="small"
                              placeholder="نحوه تسویه با تامین کننده"
                              options={supplierSettlementTypeEnum}
                              value={getValues("supplierSettlementType") || ""}
                              onChange={onChange}
                            />
                          )}
                        />
                      </Col>

                      <Col xs="12" xl="6">
                        <Controller
                          name="issueTicketType"
                          control={control}
                          // rules={{ required: true, }}
                          render={({ field: { onChange } }) => (
                            <SelectComponent
                              name="issueTicketType"
                              className="w-100 mt-3"
                              variant="outlined"
                              size="small"
                              placeholder="نوع صدور بلیط"
                              options={issueTicketTypeEnum}
                              value={getValues("issueTicketType") || ""}
                              onChange={onChange}
                            />
                          )}
                        />
                      </Col>

                      <Col
                        xs="12"
                        className={`pl-0 ${issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1 ? "opacity-50 " : ""}`}
                      >
                        <FormControlLabel
                          control={
                            <Controller
                              control={control}
                              name={"supplierAutoSettlement"}
                              render={({
                                field: { onChange, onBlur, value, name, ref },
                                fieldState: { invalid, isTouched, isDirty, error },
                              }) => (
                                <Checkbox
                                  color="primary"
                                  onBlur={onBlur}
                                  onChange={onChange}
                                  checked={
                                    issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1
                                      ? false
                                      : value || false
                                  }
                                  inputRef={ref}
                                  disabled={
                                    issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1
                                  }
                                />
                              )}
                            />
                          }
                          label="تسویه خودکار با تامین کننده"
                        />
                      </Col>
                      {showMsg && (
                        <Col className="pb-3">
                          <div className="border-primary rounded-2 px-5 py-3 text-primary bg-light-primary">
                            تسویه با تامین کننده ی {supplierIdText?.label} به مبلغ{" "}
                            {supplierSettlementPriceformattedAmount} تومان به صورت خودکار انجام می شود.
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Col>
              </Row>
              {amusementServiceReserveItem?.promoCategories.length > 0 ?
                <div className="position-relative">
                  <Row ref={scrollableBox} className="mt-7 flex-nowrap overflow-x-auto">
                    {/* ====== گروه‌های تخفیف ====== */}
                    <Col xs="12" xl="5">
                      <div className="rounded-2 px-3 py-1 pb-5 mt-5" style={{ border: "3px solid #81aced" }}>
                        <div
                          className="bg-white px-3 position-absolute d-inline-block text-primary"
                          style={{ marginTop: "-14px", width: "auto" }}
                        >
                          گروه‌های تخفیف
                    </div>
                        {amusementServiceReserveItem?.promoCategories?.map((category) => {
                          const commissionObjs = category.promoCategoryCommissions.length ? category.promoCategoryCommissions : [1];
                          return commissionObjs.map((commissionObj) => (
                            <Row
                              className="mt-5"
                              key={`discount_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`}
                            >
                              <div className="px-3 py-1 pb-5">
                                <div className="mb-2">
                                  <strong>{`${category.promoCategoryName}`}</strong>
                                </div>
                                <div className="mt-2">
                                  <Row className="align-items-center">
                                    {/* مبلغ تخفیف */}
                                    <Col xs="6">
                                      <div className="mb-3 d-flex align-items-center">
                                        <label
                                          className="small mb-0 me-1"
                                          style={{ width: "60px" }}
                                        >
                                          مبلغ:
                                    </label>
                                        <HTMLInput
                                          placeholder="مبلغ تخفیف"
                                          registeredParams={{
                                            ...register(
                                              `discountAmount_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`,
                                            )
                                          }}
                                          onInput={(e) => {
                                            if (!numberRegex.test(e.target.value.replaceAll(",", "")) && e.target.value) {
                                              e.stopPropagation()
                                              e.target.value = getValues(`discountAmount_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`)
                                              return
                                            }
                                          }}
                                          onChange={(e) => {
                                            register(
                                              `discountAmount_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`,
                                            ).onChange(e);
                                            updateProfit(
                                              e.target.value,
                                              `discountAmount_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`,
                                              category.promoCategoryId,
                                              commissionObj.promoCategoryCommisionId
                                            );
                                          }}
                                          margin="normal"
                                          variant="outlined"
                                          size="small"
                                          className="form-control text-left"
                                          title="مبلغ تخفیف"
                                          dir="ltr"
                                        />
                                      </div>
                                      <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}></div>
                                    </Col>

                                    {/* درصد تخفیف */}
                                    <Col xs="6">
                                      <div className="mb-3 d-flex align-items-center">
                                        <label
                                          className="small mb-0 me-1"
                                          style={{ width: "60px" }}
                                        >
                                          درصد:
                                    </label>
                                        <HTMLInput
                                          placeholder="درصد تخفیف"
                                          registeredParams={{
                                            ...register(
                                              `discountPercent_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`,
                                              { max: { value: 100 }, min: { value: 0 } }
                                            )
                                          }}
                                          onInput={(e) => {
                                            percentOnInput(e, `discountPercent_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`)
                                          }}
                                          onChange={(e) => {
                                            register(`discountPercent_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`,
                                            ).onChange(e);
                                            updateProfit(
                                              e.target.value,
                                              `discountPercent_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`,
                                              category.promoCategoryId,
                                              commissionObj.promoCategoryCommisionId
                                            );
                                          }}
                                          margin="normal"
                                          variant="outlined"
                                          size="small"
                                          className="form-control text-center"
                                          title="درصد تخفیف"
                                          dir="ltr"
                                        />
                                      </div>
                                      <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}>{errors[`discountPercent_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`] && "نامعتبر است (باید بین 0 تا 100 باشد)"}</div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Row>
                          ));
                        })}
                      </div>
                    </Col>

                    {/* ====== کمیسیون‌ها ====== */}
                    <Col xs="12" xl="5">
                      <div className="rounded-2 px-3 py-1 pb-5 mt-5" style={{ border: "3px solid #81aced" }}>
                        <div
                          className="bg-white px-3 position-absolute d-inline-block text-primary"
                          style={{ marginTop: "-14px", width: "auto" }}
                        >
                          کمیسیون‌ها
                    </div>
                        {amusementServiceReserveItem?.promoCategories?.flatMap((category) =>
                          (category.promoCategoryCommissions.length ? category.promoCategoryCommissions : [1]).map((commissionObj) => (
                            <Row
                              className={`mt-5 ${typeof commissionObj != "object" && "invisible"}`}
                              key={`commission_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`}
                            >
                              <div className="px-3 py-1 pb-5">
                                <div className="mb-2">
                                  <strong>{`${commissionObj.promoCategoryCommisionName}`}</strong>
                                </div>
                                <div className="mt-2">
                                  <Row className="align-items-center">
                                    {/* مبلغ کمیسیون */}
                                    <Col xs="6">
                                      <div className="mb-3 d-flex align-items-center">
                                        <label
                                          className="small mb-0 me-1"
                                          style={{ width: "60px" }}
                                        >
                                          مبلغ:
                                    </label>
                                        <HTMLInput
                                          placeholder="مبلغ کمیسیون"
                                          registeredParams={{
                                            ...register(
                                              `commissionAmount_${commissionObj.promoCategoryCommisionId}`
                                            )
                                          }}
                                          onInput={(e) => {
                                            if (!numberRegex.test(e.target.value.replaceAll(",", "")) && e.target.value) {
                                              e.stopPropagation()
                                              e.target.value = getValues(`commissionAmount_${commissionObj.promoCategoryCommisionId}`)
                                              return
                                            }
                                          }}
                                          onChange={(e) => {
                                            register(
                                              `commissionAmount_${commissionObj.promoCategoryCommisionId}`
                                            ).onChange(e);
                                            updateProfit(
                                              e.target.value,
                                              `commissionAmount_${commissionObj.promoCategoryCommisionId}`,
                                              category.promoCategoryId,
                                              commissionObj.promoCategoryCommisionId
                                            );
                                          }}
                                          margin="normal"
                                          variant="outlined"
                                          size="small"
                                          className="form-control text-left"
                                          title="مبلغ کمیسیون"
                                          dir="ltr"
                                        />
                                      </div>
                                      <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}></div>
                                    </Col>

                                    {/* درصد کمیسیون */}
                                    <Col xs="6">
                                      <div className="mb-3 d-flex align-items-center">
                                        <label
                                          className="small mb-0 me-1"
                                          style={{ width: "60px" }}
                                        >
                                          درصد:
                                    </label>
                                        <HTMLInput
                                          placeholder="درصد کمیسیون"
                                          registeredParams={{
                                            ...register(
                                              `commissionPercent_${commissionObj.promoCategoryCommisionId}`,
                                              { max: { value: 100 }, min: { value: 0 } }
                                            )
                                          }}
                                          onInput={(e) => {
                                            percentOnInput(e, `commissionPercent_${commissionObj.promoCategoryCommisionId}`)
                                          }}
                                          onChange={(e) => {
                                            register(
                                              `commissionPercent_${commissionObj.promoCategoryCommisionId}`
                                            ).onChange(e);
                                            updateProfit(
                                              e.target.value,
                                              `commissionPercent_${commissionObj.promoCategoryCommisionId}`,
                                              category.promoCategoryId,
                                              commissionObj.promoCategoryCommisionId
                                            );
                                          }}
                                          margin="normal"
                                          variant="outlined"
                                          size="small"
                                          dir="ltr"
                                          className="form-control text-center"
                                          title="درصد کمیسیون"
                                        />
                                      </div>
                                      <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}>{errors[`commissionPercent_${commissionObj.promoCategoryCommisionId}`] && "نامعتبر است (باید بین 0 تا 100 باشد)"}</div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Row>
                          ))
                        )}
                      </div>
                    </Col>

                    {/* ====== سود نهایی ====== */}
                    <Col xs="5" xl="2">
                      <div className="rounded-2 px-3 py-1 pb-5 mt-5" style={{ border: "3px solid #81aced" }}>
                        <div
                          className="bg-white px-3 position-absolute d-inline-block text-primary"
                          style={{ marginTop: "-14px", width: "auto" }}
                        >
                          سود نهایی
                        </div>
                        {amusementServiceReserveItem?.promoCategories?.flatMap((category) =>
                          (category.promoCategoryCommissions.length ? category.promoCategoryCommissions : [1]).map((commissionObj) => {
                            const profitValue = watch(`profit_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`) || "0";

                            return (
                              <Row
                                className="mt-11"
                                key={`profit_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`}
                              >
                                <div className="px-3 py-1 pb-5 mt-2">
                                  <Row className="align-items-center">
                                    <Col xs="12">
                                      <div className="mb-3 d-flex align-items-center">
                                        <HTMLInput
                                          placeholder="سود نهایی"
                                          registeredParams={{
                                            ...register(
                                              `profit_${category.promoCategoryId}_${commissionObj.promoCategoryCommisionId}`
                                            )
                                          }}
                                          margin="normal"
                                          variant="outlined"
                                          size="small"
                                          className="form-control text-left"
                                          title="سود نهایی"
                                          isDanger={(+profitValue.replaceAll(",", "") || 0) <= 0
                                            && true
                                          }
                                          dir="ltr"
                                          disabled
                                        />
                                      </div>
                                      <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}></div>
                                    </Col>
                                  </Row>
                                </div>
                              </Row>
                            );
                          })
                        )}

                      </div>
                    </Col>

                  </Row>
                  {isMobile && <div
                    className="btn-group position-absolute w-25"
                    role="group"
                    style={{
                      bottom: -13,
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "white"
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-outline-primary mr-5 rounded-3 fs-1"
                      style={{
                        height: 28,
                      }}
                      onClick={() => {
                        scrollableBox.current.scrollBy({
                          left: 200,
                          behavior: "smooth"
                        })
                      }}
                    >
                      <p className="position-relative" style={{
                        top: -8,
                        transform: "scaleX(50%)"
                      }}>
                        {"<"}
                      </p>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-primary rounded-3 fs-1"
                      style={{
                        height: 28,
                      }}
                      onClick={() => {
                        scrollableBox.current.scrollBy({
                          left: -200,
                          behavior: "smooth"
                        })
                      }}
                    >
                      <p className="position-relative" style={{
                        top: -8,
                        transform: "scaleX(50%)"
                      }}>
                        {">"}
                      </p>
                    </button>
                  </div>}
                </div>
                :
                <Col xl="6" className="d-flex mt-5" style={{
                  marginRight: "auto",
                  paddingLeft: 0,
                  paddingRight: 0
                }}>
                  <div
                    className="rounded-2 px-3 py-1 pb-5 mt-5 w-100 h-100 d-flex flex-column"
                    style={{ border: "3px solid #81aced" }}
                  >
                    <div
                      className="bg-white px-3 position-absolute d-inline-block text-primary"
                      style={{ marginTop: "-14px", width: "auto" }}
                    >
                      سود نهایی
                    </div>
                    <Row className="mt-8 pr-2 pl-5">
                      <div className="mb-3 d-flex align-items-center">
                        <span className="text-nowrap mr-3">سود نهایی :</span>
                        <HTMLInput
                          value={formatNumber(maxTakhfif)}
                          margin="normal"
                          variant="outlined"
                          size="small"
                          className="form-control text-left"
                          title="سود نهایی"
                          isDanger={maxTakhfif <= 0
                            && true
                          }
                          dir="ltr"
                          disabled
                        />
                      </div>
                    </Row>
                  </div>
                </Col>
              }

            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div >
  );
};
export default ReserveItemPricingAndCommissionModal;